import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';
import { Isenf } from '../../isentropic-flow-mdl/isenf';
import { Senf } from '../senf';

import * as math from 'mathjs';


@Component({
    selector: 'rpe-if-aat',
    templateUrl: './if-aat.component.html',
    styleUrl: './if-aat.component.scss',
    standalone: false
})
export class IfAatComponent {

  areaRatioForm: FormGroup | undefined;
  ickabod: Isenf | undefined;
  asenf: Senf | undefined;
  aBool?: boolean;


  constructor(private builder: FormBuilder, private isentropicService: IsentropicService) { }
  ngOnInit(): void {
    this.areaRatioForm = this.builder.group({
    options: ['1'],
    areaRat: ['', [
            Validators.required,
            Validators.min(1.0000001)
            ]],
    gammaVal: ['', [
            Validators.required,
            Validators.min(1.000001),
            Validators.max(1.68)
            ]]
    });
  }

  onSubmit() {
    this.aBool = true;
    this.asenf = new Senf();
    this.asenf!.areaRat = this.areaRatioForm?.get('areaRat')?.value;
    this.asenf!.gammaVal = this.areaRatioForm?.get('gammaVal')?.value;

    if  (this.areaRatioForm?.get('options')?.value === '1') {
      console.log("sub");
      let mach_sub = this.m_from_ar(
          this.areaRatioForm?.get('gammaVal')?.value, 
          this.areaRatioForm?.get('areaRat')?.value, 
          .5);
      console.log("mach_sub");
      console.log(mach_sub);
      this.asenf!.machVal = Number(mach_sub);

    } else if (this.areaRatioForm?.get('options')?.value === '2') {
      console.log("sup");
      let mach_sup = this.m_from_ar(
          this.areaRatioForm?.get('gammaVal')?.value, 
          this.areaRatioForm?.get('areaRat')?.value, 
          10);
      this.asenf!.machVal = Number(mach_sup);
    }

    this.asenf?.senfCalc(Number(this.areaRatioForm?.get('gammaVal')?.value), this.asenf!.machVal);

    console.log(this.asenf);
  }

  get areaRatio() {
    return this.areaRatioForm?.get('areaRat')
  }

  get gamma() {
    return this.areaRatioForm?.get('gammaVal');
  }


  myNewton(func:string, inputIterations:number, inputInitial:number) {
    const iterations = inputIterations || 100;
    const initial = inputInitial || 0;
    const funcCompiled = math.compile(func);
    const dydx = math.derivative(func, 'x');

    let r = initial
    for (let i = 0; i < iterations; i++) {
        r = r - funcCompiled.evaluate({ x: r }) / dydx.evaluate({ x: r })
    }
    return r
  }


  m_from_ar(ga:string, ARatio:string, guess:number) {
    const topG2:string = `(((${ga}+1)/2)^-((${ga}+1)/(${ga}-1)/2)) / x * (1 + x^2 * (${ga}-1)/2)^((${ga}+1)/(${ga}-1)/2) - ${ARatio}`;
    return this.myNewton(topG2, 100, guess)
  }

  isenMach() {
    return this.asenf?.machVal;
  }

  isenp_pt() {
    return this.asenf?.pressureRat;
  }

  isenT_Tt() {
    return this.asenf?.tempRat;
  }

  isenpA_ptAstar() {
    return this.asenf?.paptas;
  }

  isenpm() {
    return this.asenf?.pmr;
  }

  isenmach_angle() {
    return this.asenf?.machAng;
  }


  isen_cfopt() {
    return this.asenf?.cfOpt;
  }

  isen_rhot() {
    return this.asenf?.rhorhot;
  }

}